module.exports = __webpack_public_path__ + "static/img/5556_phase_function_Paper_PointsHejduk_Prediction.5ea0323.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5556_phase_function_Paper_PointsHejduk_Prediction.png
// module id = t/oZ
// module chunks = 0